import { render, staticRenderFns } from "./repairCountChart.vue?vue&type=template&id=28e38145&scoped=true&"
import script from "./repairCountChart.vue?vue&type=script&lang=js&"
export * from "./repairCountChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e38145",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e38145')) {
      api.createRecord('28e38145', component.options)
    } else {
      api.reload('28e38145', component.options)
    }
    module.hot.accept("./repairCountChart.vue?vue&type=template&id=28e38145&scoped=true&", function () {
      api.rerender('28e38145', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/components/chart/repairCountChart.vue"
export default component.exports